import { IconButton } from '../../../../../common/components/iconButton/IconButton'
import { PriceDocumentInterface } from '../../../../../common/types/interfaces'
import classes from './Item.module.sass'
import search from '../../../../../assets/images/icons/search.svg'
import edit from '../../../../../assets/images/icons/edit.svg'
import { format } from 'date-fns'
import { getPriceDocumentTypeText } from '../../../../../common/utils/functions/enumToText'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'

type Props = {
  el: PriceDocumentInterface
  showDetails: (el: PriceDocumentInterface) => void
  startEdit: (el: PriceDocumentInterface) => void
}

export const Item = ({ el, showDetails, startEdit }: Props) => {
  const darkTheme = useSelector(selectDarkTheme)
  const totalPrices = el.prices?.length || 0


  const getTypeColor = (type: number) => {
    switch (type) {
      case 0:
        return '#4CAF50'
      case 1:
        return '#F44336'
      default:
        return '#9E9E9E'
    }
  }

  return (
    <div className={darkTheme ? classes.containerDark : classes.container}>
      <div className={classes.contentContainer}>
        <div className={classes.header} style={{ color: getTypeColor(el.type) }}>
          {getPriceDocumentTypeText(el.type)}
        </div>

        <div className={classes.el}>
          <div className={classes.label}>Номер документа</div>
          <div className={classes.date}>{el.number}</div>
        </div>

        <div className={classes.el}>
          <div className={classes.label}>Дата</div>
          <div className={classes.date}>{format(new Date(el.date), 'dd.MM.yyyy HH:mm')}</div>
        </div>

        <div className={classes.el}>
          <div className={classes.label}>Позиций</div>
          <div className={classes.date}>
            {totalPrices} поз. 
          </div>
        </div>

        {el.comment && (
          <div className={classes.el}>
            <div className={classes.label}>Комментарий</div>
            <div className={classes.date}>{el.comment}</div>
          </div>
        )}
      </div>

      <div className={classes.buttons}>
        <IconButton display onClick={() => showDetails(el)} icon={search} alt="Детали" small />
      </div>
    </div>
  )
}
